/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesModule
 * Purpose		: Module for Territories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { TerritoriesService } from './Territories.service';
import { TerritoriesListComponent } from './TerritoriesList.component';
import { TerritoriesSearchComponent } from './TerritoriesSearch.component';
import { TerritoriesAddComponent } from './TerritoriesAdd.component';
import { TerritoriesEditComponent } from './TerritoriesEdit.component';
import { TerritoriesDetailsComponent } from './TerritoriesDetails.component';

import { TerritoriesRoutingModule } from './Territories-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    TerritoriesRoutingModule
  ],
  declarations: [
    TerritoriesListComponent,
	TerritoriesSearchComponent,
    TerritoriesEditComponent,
    TerritoriesAddComponent,
	TerritoriesDetailsComponent
  ],
  providers: [
    TerritoriesService
  ]
})

export class TerritoriesModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/Territories.module.ts